import page2 from '../assets/images/page2.png';
// import page3 from '../assets/images/page3.png';
import page4 from '../assets/images/page4.png';
import page5 from '../assets/images/page5.png';
import page6 from '../assets/images/page6.png';
import page7 from '../assets/images/page7.png';
import page8 from '../assets/images/page8.png';
import page9 from '../assets/images/page9.png';
import page10 from '../assets/images/page10.png';
import page11 from '../assets/images/page11.png';
import page12 from '../assets/images/page12.png';
import page13 from '../assets/images/page13.png';
import page14 from '../assets/images/page14.png';
import page15 from '../assets/images/page15.png';
import page16 from '../assets/images/page16.png';
import page17 from '../assets/images/page17.png';
import page18 from '../assets/images/page18.png';
import page19 from '../assets/images/page19.png';
import page20 from '../assets/images/page20.png';
import page21 from '../assets/images/page21.png';
import page22 from '../assets/images/page22.png';
import page23 from '../assets/images/page23.png';
import page24 from '../assets/images/page24.png';
import page25 from '../assets/images/page25.png';
import page26 from '../assets/images/page26.png';
import page27 from '../assets/images/page27.jpeg';
import page28 from '../assets/images/page28.jpeg';
import page29 from '../assets/images/page29.jpeg';
import page30 from '../assets/images/page30.jpg';
import page31 from '../assets/images/page31.jpeg';
import page32 from '../assets/images/page32.jpg';
import page33 from '../assets/images/page33.jpeg';
import page34 from '../assets/images/page34.jpeg';
import page35 from '../assets/images/page35.jpeg';
import page36 from '../assets/images/page36.jpeg';
import page37 from '../assets/images/page37.jpeg';
import page38 from '../assets/images/page38.jpeg';
import page39 from '../assets/images/page39.jpeg';
import page40 from '../assets/images/page40.jpeg';
import page41 from '../assets/images/page41.jpg';
import page42 from '../assets/images/page42.jpg';
import page43 from '../assets/images/page43.jpg';
import page44 from '../assets/images/page44.jpg';
import page45 from '../assets/images/page45.jpg';
import page46 from '../assets/images/page46.jpg';
import page47 from '../assets/images/page47.jpg';
import page48 from '../assets/images/page48.jpg';
import page49 from '../assets/images/page49.jpeg';
import page50 from '../assets/images/page50.jpeg';
import page51 from '../assets/images/page51.jpeg';
import page52 from '../assets/images/page52.jpeg';
import page53 from '../assets/images/page53.jpeg';
import page54 from '../assets/images/page54.jpeg';
import page55 from '../assets/images/page55.jpeg';
import page56 from '../assets/images/page56.jpeg';
import page57 from '../assets/images/page57.jpeg';
import page58 from '../assets/images/page58.jpeg';
import page59 from '../assets/images/page59.jpeg';
import page60 from '../assets/images/page60.jpeg';
import page61 from '../assets/images/page61.jpeg';
// import page62 from '../assets/images/page62.jpeg';
// import page63 from '../assets/images/page63.jpeg';
// import page64 from '../assets/images/page64.jpeg';
import page65 from '../assets/images/page65.jpeg';
import page66 from '../assets/images/page66.jpeg';
import page67 from '../assets/images/page67.jpeg';
import page68 from '../assets/images/page68.jpeg';
import page69 from '../assets/images/page69.jpeg';
import page70 from '../assets/images/page70.jpeg';
import page71 from '../assets/images/page71.png';
import page72 from '../assets/images/page72.png';
import page73 from '../assets/images/page73.png';
import page74 from '../assets/images/page74.png';
import page75 from '../assets/images/page75.jpeg';
import page76 from '../assets/images/page76.jpeg';
import page77 from '../assets/images/page77.jpeg';
import page78 from '../assets/images/page78.jpeg';
import page79 from '../assets/images/page79.jpeg';
import page80 from '../assets/images/page80.jpeg';
import page81 from '../assets/images/page81.jpeg';
import page82 from '../assets/images/page82.jpeg';
import page83 from '../assets/images/page83.jpeg';
import page84 from '../assets/images/page84.jpeg';
import page85 from '../assets/images/page85.jpeg';
import page86 from '../assets/images/page86.jpeg';
import page87 from '../assets/images/page87.jpeg';
import page89 from '../assets/images/0g1.png';
import page90 from '../assets/images/0g2.png';
import page91 from '../assets/images/0g3.png';
import page92 from '../assets/images/0g4.png';
import page93 from '../assets/images/0g5.png';
import page94 from '../assets/images/0g6.png';
import page95 from '../assets/images/0g7.png';
import page96 from '../assets/images/0g8.png';
import page97 from '../assets/images/indesign.jpg';

const page88 = '/videos/documentary.mp4';
const page98 = '/videos/beer.mp4';

const projects = [
    {
        index: 0,
        title: "THE SILHOUETTES",
        images: [
            { src: page18 },
            { src: page19 },
            { src: page20 },
        ],
        description: "Travail réalisé à partir de 16 silhouettes. Au but d'apprendre à chercher des vêtements de seconde main et de savoir les habiller au quotidien. Avec un vêtement upcyclé."
    },
    {
        index: 1,
        title: "LN MAGAZINE",
        images: [
            { src: page12 },
            { src: page13 },
            { src: page14 },
            { src: page15 },
            { src: page16 },
            { src: page17 },
        ],
        description: "Travail au but de montrer mon univers et mes inspirations quotidiennes, et de développement des compétences sur indesign."
    },
    {
        index: 2,
        title: "PROJECT 7",
        images: [
            { src: page21 },
            { src: page22 },
            { src: page23 }
        ],
        description: "Traitement d'un sujet sur les matières premières. La première image est nature morte minimale composée d'une assiette en argile blanche, d'un amas de farine et d'un verre d'eau croupie. J'ai voulu dénoncer les conditions de vie des victimes de guerre. Malgré tout le confort que l'on a pu avoir avant le conflit, la guerre nous a renvoyé à quelque chose de plus archaïque. Dans la matière première, je vois un retour à l'état primitif. Avant le beurre existait le lait et avant le pain existait la farine. L'assiette est l'allégorie de cette conditions humaine, j'ai opté pour l'argile car dans les croyances islamiques, il est dit qu'Adam a été crée d'un mélange d'argiles. La perforation en son centre symoblise un manque qui est nécessaire à la stabilité de tout être humain, la matière première pour un esprit sain : la sécurité."
    },
    {
        index: 3,
        title: "SOUFIE COAT",
        images: [
            { src: page7 },
            { src: page8 },
            { src: page9 },
        ],
        description: "Design, création et direction artistique. Projet inspiré des tenues des danseurs de Soufie, de la guerre et du temps. Ce projet est réalisé en laine et en polyester.",
    },
    {
        index: 4,
        title: "ABSENCE",
        images: [
            { src: page5 },
            { src: page6 },
        ],
        description: "Design, création, direction artistique et photographie. Projet de guimpe réalisé dans un workshop de knitwear. J'ai construit ce projet autour du deuil et de la réparation. Inspiré par Majd Abdel Hamid et sa pratique de la borderie comme geste lent et réparateur, le projet développe une vision personnelle du deuil : une forme de disparition temporaire, nécessaire au processus de reconstruction. À travers les matières et les textures, la guimpe devient un espace d'isolement et de transparence.",
    },
    {
        index: 5,
        title: "PACK YOUR BODY",
        images: [
            { src: page2 },
            { src: page4 },
        ],
        description: "Design, création et direction artistique. Vêtements inspirés d'emballage en carton, de corps et de dimensions, transformé en vêtements. Ce projet est réalisé en laine bouillie.",
    },
    {
        index: 6,
        title: "THE GRAPHIC SHIRT",
        images: [
            { src: page10 },
            { src: page11 },
        ],
        description: "Design, création, direction artistique et photographique. Projet réalisé dans le but de trouver une harmonie, et de créer un vêtement avec des motifs de rayures différents. Ce vêtement est créé à partir de trois tissus en polyester et en coton. Le shooting photo a eu lieu à l'espace Monte-Cristo, devant l'oeuvre de Manurel Merida intitulée Ordre et désordre. Une vidéo a été produite à l'exposition de ce projet en collaboration avec Hélène Dinke.",
    },
    {
        index: 7,
        title: "INTEGRITY",
        images: [
            { src: page24 },
            { src: page25 },
            { src: page26 }
        ],
        description: "J'ai voulu travailler autour du vêtement. J'ai pris un gilet en maille de production industrielle que j'ai détérioré puis dé-filé. Tout d'abord j'ai voulu revenir sur le concept de sécurité abordé plus haut. Après la sécurité psychique, j'ai voulu illustrer la sécurité physique car le vêtement n'est pas qu'objet d'apparat ou de distinction sociale. J'ai souhaité revenir à la nature première d'un vêtement : l'intégrité physique. S'habiller pour se protéger. Cependant, on peut également le voir sous le spectre du vêtement 'contenant', du vêtement réconfortant. Un pull que notre défunt père aurait pu laisser sur les ruines de la maison familiale par exemple. Implicitement, au travers de ce processus j'ai souhaité inverser le système de production. Au lieu d'utiliser une matière première pour la transformer en objet, j'ai voulu transformer l'objet en matière. On revient sur ce concept de changement d'état / changement de condition. La matière et l'humain ne font plus qu'un."
    },
    {
        index: 8,
        title: "PHOTOGRAPHY",
        images: [
            { src: page33 },
            { src: page27 },
            { src: page28 },
            { src: page29 },
            { src: page30 },
            { src: page31 },
            { src: page32 },
            { src: page69 },
            { src: page70 },
        ],
        description: " "
    },
    {
        index: 9,
        title: "SNS CONTENT",
        images: [
            { src: page34 },
            { src: page35 }
        ],
        description: " "
    },
    {
        index: 10,
        title: "SUPER TITANIUM EVENT",
        images: [
            { src: page48 },
            { src: page49 },
            { src: page50 },
            { src: page51 },
        ],
    },
    {
        index: 11,
        title: "FRÉDÉRIQUE CONSTANT EVENT AT LE BON MARCHÉ RIVE GAUCHE SALON PRIVÉ",
        images: [
            { src: page52 },
            { src: page53 },
        ]
    },
    {
        index: 12,
        title: "PR EVENT PARTICIPATION",
        images: [
            { src: page54, description: "Acne Studios" },
            { src: page55, description: "Acne Studios" },
            { src: page56, description: "Undercover" },
            { src: page57, description: "Undercover" },
            { src: page58, description: "Robert Wun" },
            { src: page59, description: "Robert Wun" },
            { src: page60, description: "Le Grand Dîner du Louvre" },
            { src: page61, description: "Le Grand Dîner du Louvre" },
            { src: page65, description: "Schiaparelli" },
            { src: page66, description: "Isabel Marant" },
            { src: page67, description: "Magliano" },
            { src: page68, description: "Magliano" }
        ]
    },
    {
        index: 13,
        title: "CITIZEN PRESS DAY",
        images: [
            { src: page42 },
            { src: page43 },
            { src: page44 },
            { src: page45 },
            { src: page46 },
            { src: page47 },
        ],
    },
    {
        index: 14,
        title: "IMAGE CITIZEN : TSUYOSA SHORE",
        images: [
            { src: page36 },
            { src: page37 },
            { src: page38 },
            { src: page39 },
            { src: page40 },
            { src: page41 }
        ],
        description: " "
    },
    {
        index: 15,
        title: "IMAGE CITIZEN : TSUNO CHRONO",
        images: [
            { src: page75 },
            { src: page76 },
            { src: page77 },
            { src: page78 },
            { src: page79 },
            { src: page80 },
            { src: page81 },
            { src: page82 },
            { src: page83 },
            { src: page84 },
            { src: page85 },
            { src: page86 },
            { src: page87 },
            { src: page71 },
            { src: page72 },
            { src: page73 },
            { src: page74 },
        ]
    },
    {
        index:16,
        title: "UN PAS D'AVANCE",
        images:[
        {src: page88, description: "Court métrage réalisé dans le cadre de mon année scolaire. J'ai été réalisateur de ce projet et je me suis également principalement occupé de la direction artistique, de l'image, du casting, de la production, du repérage des lieux et du stying."},
        ]
    },
    {
        index: 17,
        title: "0gramme",
        images: [
            {src: page89, description: "Réalisé avec Lisa Barbone"},
            {src: page90},
            {src: page91},
            {src: page92, description: "MOODBOARD"},
            {src: page93, description: "EXPÉRIMENTATION DE LOGO"},
            {src: page94, description: "EXPÉRIMENTATION DE LOGO"},
            {src: page95, description: "LOGO ET DÉCLINAISONS"},
            {src: page96, description: "PROTOTYPES PACKAGING"},
        ]
    },
    {
        index: 18,
        title: "CITIZEN AD",
        images:[
            {src: page97, description: "Adaptation de taille sur indesign pour les page de publicité en magazine."},
        ]
    },
    {
        index: 18,
        title: "REEB",
        images:[
            {src: page98, description: "Nous avons réalisé une publicité pour une bière sans alcool, avec l'objectif de mettre en avant l'image et l'univers que la marque souhaite véhiculer. Nous avons cherché à créer une esthétique cohérente avec les attentes du client et à transmettre une identité visuelle forte à travers la publicité. Sur ce projet, je me suis principalement occupé du casting, du styling et du repérage des lieux, afin de construire une direction artistique cohérente avec l'univers imaginé pour la campagne."},
        ]
    },
];

export default projects;